<script lang="ts">
  import chaptersStore from '../../../stores/chapters.svelte'
  import videoStore from '../../../stores/video.svelte'
  import ChaptersIcon from '../icons/ChaptersIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'

  let hasChapters = $derived((chaptersStore.state.cues || []).length > 0)

  async function handleChaptersButtonClick() {
    chaptersStore.openChaptersScreen(videoStore.state.isPlaying)
    videoStore.state.videoController?.pause()
  }
</script>

<ControlBarButton
  hidden={!hasChapters}
  onclick={() => handleChaptersButtonClick()}
  tooltip="Chapters"
>
  <ChaptersIcon />
</ControlBarButton>
